import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import MembershipGoals from "./smartComponents/MembershipGoals";
import AttendanceGoals from "./smartComponents/AttendanceGoals";
import DailyPulseGoals from "./smartComponents/DailyPulseGoals";
import RetentionGoals from "./smartComponents/RetentionGoals";
import RevenueGoals from "./smartComponents/RevenueGoals";
import LoadingAnimation from "../../components/loadingAnimation/loadingAnimation";
import { actionCreators } from "./redux/goalsSagas";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { queryParams } from "../../utils/queryParams";
import { UploadGoals } from "./smartComponents/UploadGoals";
import DatePicker from "./smartComponents/DatePicker";
import ViewFilter from "./smartComponents/ViewFilter";
import TopGoals from "./smartComponents/TopGoals";

export function getGoalValue(item) {
  const goal = item.goalValue;

  if (!goal || !isFinite(goal)) {
    return 0;
  }

  const percent = (item.currentVal / goal) * 100;

  return item.goalUsesPercent ? Math.round(percent) : percent;
}

export function getForecastValue(item) {
  const goal = item.goalValue;
  const value = item.currentValPacing;

  if (!goal || !isFinite(goal)) {
    return 0;
  }

  const percent = (value / goal) * 100;

  return item.goalUsesPercent ? Math.round(percent) : percent;
}

const GoalsModule = (props) => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.goals.isLoading);
  const { short_url, can_modify_goals, singleLocation } = useSelector(
    (state) => state.goals.currentUser
  );
  const isCurrentMonth = useSelector((state) => state.goals.isCurrentMonth);

  useEffect(() => {
    dispatch(actionCreators.fetchCurrentUser(props));
  }, []);

  return (
    <div className="goals-module">
      <div className="page-controls">
        <div className="page-controls__filters">
          {!singleLocation && (
            <div className="page-controls__filter page-controls__filter--view ">
              <p>View</p>
              <ViewFilter />
            </div>
          )}

          <div className="page-controls__filter page-controls__filter--date">
            <p>Date</p>
            <DatePicker />
          </div>
        </div>
        {isCurrentMonth && (
          <div className="page-controls__actions">
            <a
              className="download-btn"
              title="Export to Excel"
              href={`${queryParams.apiVersion}goals/export?short_url=${short_url}`}
            >
              <FontAwesomeIcon
                style={{ color: "#8fc447", marginLeft: "8px", verticalAlign: "bottom" }}
                width={15}
                height={15}
                icon={faDownload}
              />
            </a>
            {can_modify_goals && <UploadGoals />}
          </div>
        )}
      </div>

      {isLoading ? (
        <LoadingAnimation />
      ) : (
        <div>
          <TopGoals />
          <AttendanceGoals />
          <MembershipGoals />
          <RevenueGoals />
          <RetentionGoals />
          <DailyPulseGoals />
        </div>
      )}
    </div>
  );
};

export default GoalsModule;
